module.exports = __webpack_public_path__ + "media/images/faces/male/26-4cf2d9edcd625dbcabfa64422bfb23b5.jpg";